/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedInteriorsArticles_editorial = {
    readonly articles: ReadonlyArray<{
        readonly publishedDate: string;
        readonly title: string;
        readonly imageUrl: {
            readonly thumb: string;
            readonly medium: string;
            readonly full: string;
        };
        readonly subtitle: string;
        readonly link: string;
        readonly source: string;
    }> | null;
    readonly " $refType": "SbSharedInteriorsArticles_editorial";
};
export type SbSharedInteriorsArticles_editorial$data = SbSharedInteriorsArticles_editorial;
export type SbSharedInteriorsArticles_editorial$key = {
    readonly " $data"?: SbSharedInteriorsArticles_editorial$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedInteriorsArticles_editorial">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedInteriorsArticles_editorial",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "WordpressArticleType",
      "kind": "LinkedField",
      "name": "articles",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "publishedDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "WordpressArticleImageType",
          "kind": "LinkedField",
          "name": "imageUrl",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "thumb",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "medium",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "full",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "subtitle",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "link",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "source",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "WordpressArticlesType",
  "abstractKey": null
};
(node as any).hash = '6cfe8c9419e184b53659c328e41d47d5';
export default node;
